import { Credentials } from "@fairfleet/geotab";
import LoadingButton from "@mui/lab/LoadingButton";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { useMutation } from "@tanstack/react-query";
import { FormEvent, useState } from "react";
import { useGeotabClient } from "../GeotabClientContext";

const Container = styled("form")`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface Props {
  /** Called on successful login. */
  onLoggedIn(credentials: Credentials): void;
}

export function LoginPage({ onLoggedIn }: Props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [database, setDatabase] = useState("");
  const { mutate: login, isPending } = useLogin();

  function onLogin(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    login(
      {
        username,
        password,
        database,
      },
      {
        onSuccess: onLoggedIn,
      },
    );
  }
  return (
    <Container onSubmit={onLogin}>
      <Stack width={420} gap={2}>
        <TextField
          type="text"
          label="Username"
          value={username}
          onChange={e => setUsername(e.target.value)}
        />

        <TextField
          type="password"
          label="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />

        <TextField label="Database" value={database} onChange={e => setDatabase(e.target.value)} />

        <LoadingButton type="submit" size="large" variant="contained" loading={isPending}>
          {"Login"}
        </LoadingButton>
      </Stack>
    </Container>
  );
}

function useLogin() {
  interface Args {
    username: string;
    password: string;
    database: string;
  }
  const { geotabClient, updateGeotabClient } = useGeotabClient();
  const nullIfEmpty = (str: string) => (str.trim() === "" ? undefined : str.trim());

  return useMutation({
    mutationFn: async (args: Args) => {
      const username = args.username.trim();
      const password = args.password.trim();
      const database = nullIfEmpty(args.database);
      if (username.includes("geotab")) {
        throw new Error("Invalid username");
      }

      const { credentials } = await geotabClient.authenticate(username, password, database);
      updateGeotabClient(credentials);
      return credentials;
    },
  });
}
